import React from "react";
import { IconButton } from "@mui/material";
import Badge from "@mui/material/Badge";
import { Image } from "antd";
import Tooltip from "@mui/material/Tooltip";
import VideoPlayer from "./VideoPlayer";
import VirtualTourRenderer from "./VirtualTourRenderer";

const SharedPropertyCard = ({
  data = {},
  parseAvailabilityDate = () => {},
  handleNotesModalOpen = () => {},
  updateFavorite = () => {},
  hideUnits = () => {},
}) => {
  const { units = {} } = data;
  const { property = {} } = units;

  const { date, month } = parseAvailabilityDate(
    units?.unit_availability_text || ""
  );

  const utcDate = new Date(data?.created_at || "");
  const options = { year: "numeric", month: "long", day: "numeric" };
  const localDate = utcDate.toLocaleDateString(undefined, options);

  console.log({ data }, "data");

  return (
    <div className="relative border-t-2 border-[#d1d1d1] first:border-t-0 shadow-sm p-4 w-full bg-white text-[#596962] max-w-6xl">
      {/* Property Added Date */}
      <p className="text-gray-500 text-md italic mt-4 mb-3">
        {`Property added on ${localDate || ""}`}
      </p>

      {/* Main Content */}
      <div className="flex gap-4">
        {/* Left Section - Virtual Tour */}
        <div className="relative w-1/2 flex-1">
          {!units?.floor_plan_video ? (
            <div className="flex items-center justify-center w-full h-full rounded-md">
              <Image
                src={units?.floor_plan}
                fallback="data:image/png;base64,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"
                alt="Thumbnail"
                className="rounded-xl object-cover"
                style={{ minHeight: 250, maxHeight: 300, objectFit: "cover" }}
              />
            </div>
          ) : units?.floor_plan_video &&
            units?.floor_plan_video?.includes("videoUrl") ? (
            <VideoPlayer data={units?.floor_plan_video} />
          ) : (
            <VirtualTourRenderer data={units?.floor_plan_video} />
          )}
        </div>

        {/* Right Section - Property Details */}

        <div className="w-1/2 flex justify-between">
          <div className="flex flex-col pl-6">
            <div className="">
              {data?.units?.property?.year_built >= 2025 && <div className="flex justify-end py-2"><span className="bg-green-600 text-white text-sm font-semibold px-2 py-1 rounded-md leading-none">
    New Construction
  </span></div>}
              <div className="mb-3 flex items-start gap-3">
                
                <a
                  href={property?.website || "#"}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[40px] font-playfair font-semibold underline underline-offset-0.5 decoration-[1.5px] p-0 leading-none text-wrap"
                >
                  {data?.title_text || ""}
                </a> 
              </div>
               <p className="text-[18px] font-inter italic">
                {data?.higher_escort_note || ""}
              </p>
              

              <p className="text-[20px] font-inter mt-2">
                {data?.sub_market_bd_ba_sqft_text || ""}
              </p>

              {/* {data?.special_price_text?.trim()?.length ? (
                <div className="text-[26px] font-inter flex gap-1 items-center font-bold mt-2">
                  <span className="line-through">{data?.price_text || ""}</span>
                  <span className="ml-2">{data?.special_price_text || ""}</span>
                </div>
              ) : (
                <div className="text-[26px] font-inter flex gap-1 items-center font-bold mb-4 mt-2">
                  <span className="">{data?.price_text || ""}</span>
                </div>
              )} */}
            </div>

            <div className={`text-[20px] ${data?.special_calc_text ?' mt-3 ' : ' mt-2 '}flex flex-col gap-2`}>
              {data?.special_calc_text ? (
                <p className="">{data?.special_calc_text || ""}</p>
              ) : null}

               {data?.special_price_text?.trim()?.length ? (
                <div className="text-[26px] font-inter flex gap-1 items-center font-bold">
                  <span className="line-through">{data?.price_text || ""}</span>
                  <span className="ml-2">{data?.special_price_text || ""}</span>
                </div>
              ) : (
                <div className="text-[26px] font-inter flex gap-1 items-center font-bold mb-4 mt-2">
                  <span className="">{data?.price_text || ""}</span>
                </div>
              )}

              <p className="">{data?.unit_model_text || ""}</p>
              <p className="font-normal">
                <span className="font-semibold">Available:</span>{" "}
                {data?.availability_holdtime_text
                  ?.replace("Available:", "")
                  ?.trim() || ""}
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-3 items-center justify-center bg-white">
            <Badge
              color="success"
              variant="dot"
              invisible={Boolean(!data?.notes?.length)}
            >
              <Tooltip title="Add notes">
                <IconButton
                  disableRipple
                  onClick={() => handleNotesModalOpen(data)}
                >
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 48 52"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="pl-[2px]"
                  >
                    <g clip-path="url(#clip0_244_2628)">
                      <path
                        d="M38.8395 34.7453V46.0349C38.8395 48.274 37.04 50.0895 34.8208 50.0895H5.24626C3.027 50.0895 1.22754 48.274 1.22754 46.0349V5.62104C1.22754 3.38195 3.027 1.56641 5.24626 1.56641H34.8196C37.0388 1.56641 38.8383 3.38195 38.8383 5.62104V18.6816"
                        stroke="#596962"
                        stroke-width="3"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                      />
                      <path
                        d="M10.5796 14.1465H29.4875"
                        stroke="#596962"
                        stroke-width="3"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                      />
                      <path
                        d="M10.5796 25.8301H29.4875"
                        stroke="#596962"
                        stroke-width="3"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                      />
                      <path
                        d="M10.5796 37.5098H23.2875"
                        stroke="#596962"
                        stroke-width="3"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                      />
                      <path
                        d="M29.6777 36.5211L31.1482 32.9012L43.7727 20.1602L45.5489 21.7751V21.9534L32.879 34.7353L29.6777 36.5211Z"
                        fill="#596962"
                      />
                      <path
                        d="M46.3428 17.6919C46.6374 17.6262 46.7835 17.6881 47.0155 17.8491C47.1186 17.921 47.871 18.7495 47.9275 18.8473C48.3743 19.6176 46.6288 20.6678 46.2373 21.2499L44.5569 19.4752C45.0172 19.1557 45.885 17.7934 46.3428 17.6919Z"
                        fill="#596962"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_244_2628">
                        <rect
                          width="48"
                          height="51"
                          fill="white"
                          transform="translate(0 0.328125)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </IconButton>
              </Tooltip>
            </Badge>
            <Tooltip
              title={
                Boolean(data?.favorite)
                  ? "Remove from favorites"
                  : "Add to favorites"
              }
            >
              <IconButton
                onClick={() => updateFavorite(data?.id)}
                disableRipple
              >
                {Boolean(data?.favorite) ? (
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 55 52"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.8175 0.853648C18.8011 0.184999 24.3306 3.08558 27.4604 8.19022C37.5988 -7.12371 59.3791 3.17535 54.224 21.2629C50.8977 32.9302 36.6138 44.4614 27.4604 51.7515C18.439 44.5357 4.06918 33.0231 0.761325 21.5106C-1.92669 12.1371 2.59936 1.99283 12.8175 0.853648Z"
                      fill="#FF0000"
                    />
                  </svg>
                ) : (
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 55 52"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.9841 1.72132C8.38837 2.23368 5.12144 4.74391 3.27037 8.18226C1.40076 11.655 0.956535 16.126 2.203 20.4733C3.75038 25.8579 7.94796 31.3928 13.0377 36.5674C17.7564 41.3647 23.0987 45.713 27.4622 49.2086C31.8794 45.681 37.2359 41.3077 41.9544 36.4774C47.0383 31.2731 51.2234 25.6936 52.7815 20.2286C55.1577 11.891 51.3407 5.53616 45.9266 2.92948C40.5163 0.324638 33.3556 1.37987 28.7112 8.39521C26.1817 3.71205 18.355 1.12114 12.9841 1.72132Z"
                      stroke="#596962"
                      stroke-width="3"
                      // fill="#FFFFFF"
                    />
                  </svg>
                )}
              </IconButton>
            </Tooltip>
            <Tooltip title={Boolean(data?.hidden) ? "Revert hide" : "Hide"}>
              <IconButton onClick={() => hideUnits(data?.id)} disableRipple>
                {Boolean(data?.hidden) ? (
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 52 52"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="25.6912"
                      cy="25.7771"
                      r="23.9998"
                      stroke="#596962"
                      stroke-width="3"
                    />
                  </svg>
                ) : (
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 52 52"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="26"
                      cy="26"
                      r="24"
                      stroke="#596962"
                      stroke-width="3"
                    />

                    <line
                      x1="10"
                      y1="42"
                      x2="42"
                      y2="10"
                      stroke="#596962"
                      stroke-width="3"
                    />
                  </svg>
                )}
              </IconButton>
            </Tooltip>
          </div>
        </div>
      </div>
      {/* Thumbnail Images */}
      <div className="flex items-center overflow-x-auto gap-4 mt-6 mb-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
        {[1].map((index) => (
          <Image
            key={index}
            src={units?.floor_plan}
            fallback="data:image/png;base64,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"
            alt="Thumbnail"
            style={{
              maxHeight: 150,
              minHeight: 150,
              minWidth: 150,
              maxWidth: 150,
            }}
            className="rounded-xl object-cover border-[2px]"
          />
        ))}
      </div>

      {/* Floating Action Icons */}
    </div>
  );
};

export default SharedPropertyCard;
